module.exports = __webpack_public_path__ + "img/logo.c5585fe3.svg";